import React from 'react';
import { Helmet } from 'react-helmet';
import {PROJECT} from '../utils/constant';
const MetaTags = () => {
    const data = {
        title: PROJECT.NAME,
        description: PROJECT.SLOGAN,
        url: 'https://www.lomasdonquifo.com',
        image: 'https://www.lomasdonquifo.com/og-image.jpg',
        siteName: PROJECT.NAME,
        keywords: 'Solares en venta Constanza,  Terrenos en venta Constanza, Propiedades en Constanza, Inversión en Constanza, montaña, Real estate Dominican Republic, Real estate Constanza, Cómo invertir en propiedades en Constanza, Proyectos inmobiliarios Constanza, lifestyle, mountain, nature, real estate, comprar terreno, terreno, constanza, calidad de vida, naturaleza',
    };

    return (
        <Helmet>
            <meta charSet="UTF-8"/>
            <title>{data.title}</title>
            <meta name="keywords" content={data.keywords}/>
            <meta name="description" content={data.description}/>
            <meta property="og:title" content={data.title}/>
            <meta property="og:description" content={data.description}/>
            <meta property="og:url" content={data.url}/>
            <meta property="og:image" content={data.image}/>
            <meta property="og:site_name" content={data.siteName}/>
            <meta property="og:type" content="website"/>
            <link rel="canonical" href={data.url} />
        </Helmet>
    );
};

export default MetaTags;
